<template>
  <div class="brands-carousel-container">
    <Swiper
      :spaceBetween="30"
      :slidesPerView="1"
      :loop="true"
      :autoplay="{
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }"
      :speed="3000"
      :modules="modules"
      class="mySwiper"
    >
      <SwiperSlide v-for="(brand, index) in brands" :key="index">
        <img :src="brand.src" :alt="brand.alt || 'Brand Logo'" class="brand-logo" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/autoplay'

import { defineProps, type PropType } from 'vue'

interface Brand {
  src: string
  alt?: string
}

defineProps({
  brands: {
    type: Array as PropType<Brand[]>,
    required: true
  }
})

const modules = [Autoplay]
</script>

<style scoped>
.brands-carousel-container {
  background-color: var(--color-shadow-border);
  border-radius: 5px;
}

.mySwiper {
  width: 100%;
  height: 60px; /* Altura do carrossel */
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.brand-logo {
  max-height: 60px; /* Altura máxima dos logos */
  width: auto; /* Mantém a proporção */
  filter: grayscale(0%); /* Opcional: logos em tons de cinza */
  opacity: 1; /* Opcional: transparência */
  transition:
    filter 0.3s ease,
    opacity 0.3s ease;
}

.brand-logo:hover {
  filter: grayscale(10%); /* Opcional: cor ao passar o mouse */
  opacity: 0.6; /* Opcional: opacidade total ao passar o mouse */
  border: 1px solid var(--color-border);
  border-radius: 10px; /* Bordas arredondadas */
  cursor: pointer;
}
</style>
